import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import TableSkeleton from "./TableSkeleton";
import PaginationSkeleton from "./PaginationSkeleton";

const TransferListSkeleton = () => (
    <div className="my-5">
        <div className="row accountDetail">
            <div className="col-4"></div>
            <div className="col-3"></div>
            <div className="col-4">
                <Skeleton variant="rectangular" height={40} />
            </div>
        </div>
        <TableSkeleton/>
        <div className="row">
                <PaginationSkeleton/>
        </div>

    </div>
);

export default TransferListSkeleton;